import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const popLogin = (callbackPath) => {
  const redirectUrl = window.location.origin + (callbackPath === '/diagnostic/auth/callback' ? callbackPath : '/pop/auth/callback');
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const popExchangeSession  = (sessionId) => client.post('/pop/auth/session', { session_id: sessionId }).then((r) => r.data);
export const popMe               = () => client.get('/pop/auth/me').then((r) => r.data);
export const popLogout           = () => client.post('/pop/auth/logout').then((r) => r.data);

// Profile
export const popUpdateProfile    = (payload) => client.patch('/pop/profile', payload).then((r) => r.data);
export const popGetProfile       = (userId) => client.get(`/pop/profile/${userId}`).then((r) => r.data);

// Directory & stats
export const popDirectory        = (params = {}) => client.get('/pop/directory', { params }).then((r) => r.data);
export const popStats            = () => client.get('/pop/stats').then((r) => r.data);

// Opportunities
export const popListOpportunities   = (params = {}) => client.get('/pop/opportunities', { params }).then((r) => r.data);
export const popCreateOpportunity   = (payload)     => client.post('/pop/opportunities', payload).then((r) => r.data);
export const popGetOpportunity      = (id)          => client.get(`/pop/opportunities/${id}`).then((r) => r.data);

// Applications
export const popApply                 = (payload)                => client.post('/pop/applications', payload).then((r) => r.data);
export const popMyApplications        = ()                        => client.get('/pop/applications/mine').then((r) => r.data);
export const popReceivedApplications  = ()                        => client.get('/pop/applications/received').then((r) => r.data);
export const popUpdateApplicationStatus = (id, status, note = '') => client.patch(`/pop/applications/${id}/status`, { status, note }).then((r) => r.data);

// Invitations
export const popInvite            = (payload) => client.post('/pop/invitations', payload).then((r) => r.data);
export const popMyInvitations     = ()         => client.get('/pop/invitations/mine').then((r) => r.data);

// Admin
export const popVerificationQueue = () => client.get('/pop/admin/verification-queue').then((r) => r.data);
export const popVerifyUser        = (userId, status, note = '') => client.patch(`/pop/admin/users/${userId}/verify`, { status, note }).then((r) => r.data);
export const popSetRole           = (userId, role) => client.patch(`/pop/admin/users/${userId}/role`, { role }).then((r) => r.data);

// Messaging
export const popCreateThread      = (payload) => client.post('/pop/messaging/threads', payload).then((r) => r.data);
export const popListThreads       = () => client.get('/pop/messaging/threads').then((r) => r.data);
export const popGetThread         = (id) => client.get(`/pop/messaging/threads/${id}`).then((r) => r.data);
export const popSendMessage       = (id, body) => client.post(`/pop/messaging/threads/${id}/messages`, { body }).then((r) => r.data);

// Events
export const popCreateEvent       = (payload) => client.post('/pop/events', payload).then((r) => r.data);
export const popListEvents        = (params = {}) => client.get('/pop/events', { params }).then((r) => r.data);
export const popRegisterEvent     = (id) => client.post(`/pop/events/${id}/register`).then((r) => r.data);
export const popMyEvents          = () => client.get('/pop/events/mine').then((r) => r.data);

// Content (courses / research / case_study)
export const popCreateContent     = (payload) => client.post('/pop/content', payload).then((r) => r.data);
export const popListContent       = (params = {}) => client.get('/pop/content', { params }).then((r) => r.data);
export const popGetContent        = (id) => client.get(`/pop/content/${id}`).then((r) => r.data);

// AI Scoring
export const popAIScore           = (opportunity_id, user_id) => client.post('/pop/ai/score', { opportunity_id, user_id }).then((r) => r.data);

// -------------------------------------------------------------------
// Phase 3 · Enrollments, Mentorship, Ratings, Gaps, Q&A, Analytics
// -------------------------------------------------------------------

// Enrollments (courses / research / events)
export const popEnroll              = (subject_type, subject_id) => client.post('/pop/enrollments', { subject_type, subject_id }).then((r) => r.data);
export const popMyEnrollments       = () => client.get('/pop/enrollments/mine').then((r) => r.data);
export const popUpdateProgress      = (id, progress_pct, status) => client.patch(`/pop/enrollments/${id}/progress`, { progress_pct, status }).then((r) => r.data);
export const popEnrollmentCount     = (subject_type, subject_id) => client.get(`/pop/enrollments/counts/${subject_type}/${subject_id}`).then((r) => r.data);

// Mentorship slots + bookings
export const popCreateSlot          = (payload) => client.post('/pop/mentor-slots', payload).then((r) => r.data);
export const popListSlots           = (params = {}) => client.get('/pop/mentor-slots', { params }).then((r) => r.data);
export const popBookSlot            = (slot_id, question = '') => client.post('/pop/bookings', { slot_id, question }).then((r) => r.data);
export const popMyBookings          = () => client.get('/pop/bookings/mine').then((r) => r.data);
export const popUpdateBookingStatus = (id, status) => client.patch(`/pop/bookings/${id}/status`, { status }).then((r) => r.data);

// Ratings & Feedback
export const popRate                = (subject_type, subject_id, stars, review = '') => client.post('/pop/ratings', { subject_type, subject_id, stars, review }).then((r) => r.data);
export const popRatings             = (subject_type, subject_id) => client.get('/pop/ratings', { params: { subject_type, subject_id } }).then((r) => r.data);
export const popRatingSummary       = (subject_type, subject_id) => client.get(`/pop/ratings/summary/${subject_type}/${subject_id}`).then((r) => r.data);

// Curriculum Gaps (Faculty flag → Industry Expert responds)
export const popFlagGap             = (payload) => client.post('/pop/curriculum-gaps', payload).then((r) => r.data);
export const popListGaps            = (params = {}) => client.get('/pop/curriculum-gaps', { params }).then((r) => r.data);
export const popExpressGapInterest  = (id) => client.post(`/pop/curriculum-gaps/${id}/express-interest`).then((r) => r.data);

// Ask-a-Practitioner Q&A
export const popAskQuestion         = (payload) => client.post('/pop/questions', payload).then((r) => r.data);
export const popListQuestions       = (params = {}) => client.get('/pop/questions', { params }).then((r) => r.data);
export const popGetQuestion         = (id) => client.get(`/pop/questions/${id}`).then((r) => r.data);
export const popAnswerQuestion      = (id, body) => client.post(`/pop/questions/${id}/answers`, { body }).then((r) => r.data);
export const popUpvoteQuestion      = (id) => client.post(`/pop/questions/${id}/upvote`).then((r) => r.data);

// HEI Committee Pipeline & Analytics
export const popApplicationPipeline = () => client.get('/pop/applications/pipeline').then((r) => r.data);
export const popUniversityAnalytics = () => client.get('/pop/analytics/university').then((r) => r.data);

// Expert Impact (Industry-Expert dashboard)
export const popExpertImpact        = () => client.get('/pop/impact/expert').then((r) => r.data);

// Resume (Industry-Expert profile)
export const popUploadResume        = (file, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return client.post('/pop/profile/resume', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then((r) => r.data);
};
export const popDeleteResume        = () => client.delete('/pop/profile/resume').then((r) => r.data);
export const popResumeDownloadUrl   = (user_id) => `${API}/pop/profile/resume/${user_id}`;

// -------------------------------------------------------------------
// Phase 4 · Books Marketplace
// -------------------------------------------------------------------
export const popListBooks           = (params = {}) => client.get('/pop/books', { params }).then((r) => r.data);
export const popMyBooks             = () => client.get('/pop/books/mine').then((r) => r.data);
export const popBookCategories      = () => client.get('/pop/books/categories').then((r) => r.data);
export const popGetBook             = (id) => client.get(`/pop/books/${id}`).then((r) => r.data);
export const popCreateBook          = (payload) => client.post('/pop/books', payload).then((r) => r.data);
export const popUpdateBook          = (id, payload) => client.patch(`/pop/books/${id}`, payload).then((r) => r.data);
export const popDeleteBook          = (id) => client.delete(`/pop/books/${id}`).then((r) => r.data);
export const popRegisterBookClick   = (id) => client.post(`/pop/books/${id}/click`).then((r) => r.data);
export const popUploadBookCover     = (id, file, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return client.post(`/pop/books/${id}/cover`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then((r) => r.data);
};
export const popBookCoverUrl        = (id) => `${API}/pop/books/${id}/cover`;

// Book orders (SAMANVAI direct-buy pipeline)
export const popCreateBookOrder     = (payload) => client.post('/pop/book-orders', payload).then((r) => r.data);
export const popListBookOrders      = (params = {}) => client.get('/pop/book-orders', { params }).then((r) => r.data);
export const popMyBookOrders        = () => client.get('/pop/book-orders/mine').then((r) => r.data);
export const popUpdateBookOrder     = (id, status, admin_note = '') => client.patch(`/pop/book-orders/${id}/status`, { status, admin_note }).then((r) => r.data);

// -------------------------------------------------------------------
// Phase 5 · AI-Enabled MBA (flagship program)
// -------------------------------------------------------------------
export const popMBASubmitInterest   = (payload) => client.post('/pop/ai-mba/interest', payload).then((r) => r.data);
export const popMBAListInterest     = (params = {}) => client.get('/pop/ai-mba/interest', { params }).then((r) => r.data);
export const popMBAUpdateInterest   = (id, status, admin_note = '') => client.patch(`/pop/ai-mba/interest/${id}/status`, { status, admin_note }).then((r) => r.data);
export const popMBAStats            = () => client.get('/pop/ai-mba/stats').then((r) => r.data);
export const popMBADownloadProspectus = async ({ recipient, email, phone }) => {
  const url = `${API}/pop/ai-mba/prospectus.pdf`;
  const resp = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ recipient, email, phone }),
  });
  if (!resp.ok) {
    let detail = `Download failed (HTTP ${resp.status})`;
    try {
      const j = await resp.json();
      if (typeof j.detail === 'string') detail = j.detail;
      else if (Array.isArray(j.detail) && j.detail[0]?.msg) detail = j.detail[0].msg;
    } catch (_) { /* keep default */ }
    const err = new Error(detail);
    err.status = resp.status;
    throw err;
  }
  const blob = await resp.blob();
  // Preserve backend-suggested filename when present
  let filename = 'SAMANVAI_AI_Enabled_MBA_Prospectus.pdf';
  const disp = resp.headers.get('content-disposition') || '';
  const m = disp.match(/filename="([^"]+)"/);
  if (m) filename = m[1];
  const objUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(objUrl), 1500);
  return { filename, size: blob.size };
};
export const popMBAListProspectusDownloads = (limit = 200) =>
  client.get('/pop/ai-mba/prospectus/downloads', { params: { limit } }).then((r) => r.data);
export const popCreateAdvisorBooking = (payload) =>
  client.post('/pop/ai-mba/advisor-bookings', payload).then((r) => r.data);
export const popListAdvisorBookings  = (limit = 200) =>
  client.get('/pop/ai-mba/advisor-bookings', { params: { limit } }).then((r) => r.data);
export const popUpdateAdvisorBookingStatus = (id, status, admin_note = '') =>
  client.patch(`/pop/ai-mba/advisor-bookings/${id}/status`, { status, admin_note }).then((r) => r.data);

export const ROLES = [
  { id: 'industry_expert', label: 'Industry Expert / Professor of Practice', hint: 'Serving or aspiring PoP from industry' },
  { id: 'university',      label: 'University / HEI Administrator',           hint: 'Post opportunities, invite experts, review applications' },
  { id: 'faculty',         label: 'Faculty / Academic Expert',                hint: 'Co-design courses with industry PoPs' },
  { id: 'student',         label: 'Student',                                  hint: 'Discover mentors, sessions, and case studies' },
  { id: 'industry_org',    label: 'Industry Organisation',                    hint: 'Sponsor engagements, nominate experts' },
];

export const ENGAGEMENT_ROUTES = [
  { id: 'industry_funded', label: 'Industry-funded',  hint: 'Employer covers honorarium; PoP retains industry role' },
  { id: 'hei_funded',      label: 'HEI-funded',       hint: 'University pays honorarium under UGC framework' },
  { id: 'honorary',        label: 'Honorary',         hint: 'Pro-bono engagement; no honorarium' },
];

export const roleLabel = (roleId) => (ROLES.find((r) => r.id === roleId) || {}).label || roleId;
